module.exports = __webpack_public_path__ + "assets/img/theX-content-2.94744cd9.png";